<!-- <div
	*ngIf="nodeEditorService.currentGameData"
	class="row g-0"
	style="position: fixed; bottom: 10px; right: 10px; z-index: 9999"
>
	<div class="col">
		<button
			type="button"
			class="btn btn-sm btn-primary ms-3 px-4 py-2"
			aria-label="Open node editor"
			(click)="OpenNodeEditor()"
		>
			<i class="bi bi-diagram-3"></i>
		</button>
	</div>
</div> -->

<div
	class="row mb-2 g-0 pb-2 bg-white"
	style="position: sticky; top: 0; z-index: 100; margin-top: -3px"
>
	<div class="w-100" style="height: 32px"></div>
	<div class="col-12 d-flex justify-content-center align-items-center">
		<div class="button-center-group">
			<button
				class="btn btn-secondary btn-lg me-1 shadow-sm"
				(click)="openFileUploadModal()"
			>
				<i class="bi bi-cloud-arrow-up"></i> Lisää tiedostoja...
			</button>
			<button
				class="btn btn-primary btn-lg shadow-sm"
				(click)="StartArticlesExport()"
				[title]="
					hasActiveBatchJobs
						? 'Taustalla luodaan pelejä. Odota, että ne valmistuvat.'
						: ''
				"
			>
				<i class="bi bi-stars"></i>
				@if (sourceMaterialService.SelectedArticles.length === 0) {
					Luo peli...
				} @else {
					Luo peli valituista ({{
						sourceMaterialService.SelectedArticles.length
					}})...
				}
			</button>
		</div>
	</div>
</div>

<div class="container my-4 pb-5">
	<!-- <ul ngbNav #nav="ngbNav" [activeId]="2" class="nav-pills pb-2">
        <li [ngbNavItem]="1" role="presentation">
        
        </li>

        <li ngbNavItem>
            
            <div class="btn-group btn-group-sm ps-4" role="group" aria-label="Valitse tag- tai artikkelinäkymän välillä">
                <input type="radio" class="btn-check" name="tagSelectionRadio" id="tagSelectionRadio1" autocomplete="off" [checked]="selectedView == 'tags'" (click)="selectedView = 'tags'">
                <label class="btn btn-outline-secondary" for="tagSelectionRadio1">Tagit</label>
        
                <input type="radio" class="btn-check" name="tagSelectionRadio" id="tagSelectionRadio2" autocomplete="off" [checked]="selectedView == 'articles'" (click)="selectedView = 'articles'">
                <label class="btn btn-outline-secondary" for="tagSelectionRadio2">Tiedostot</label>
            </div>
        </li>
    </ul> -->

	<!-- Articles View -->
	@if (selectedView == "articles") {
		@if (sourceMaterialService.Initialized) {
			<div
				class="row g-0 mb-2"
				*ngIf="(sourceMaterialService.articles$ | async)?.length == 0"
			>
				<div class="col-12 text-center">
					<h3 class="pt-5 mb-4">Ei tiedostoja.</h3>
					<p>
						Aloita lisäämällä tiedostoja. Luo pelejä tiedostoista
						valitsemalla ladattu tiedosto ja valitsemalla sen
						jälkeen <b>Luo peli</b>.
					</p>
				</div>
			</div>

			<div
				class="mb-5"
				*ngIf="(sourceMaterialService.articles$ | async)?.length! > 0"
			>
				<app-article-search-list
					[sourceArticles]="
						(sourceMaterialService.articles$ | async) || []
					"
					[searchText]="myArticlesSearch"
					[owner]="'me'"
					[tableTitle]="'Tiedostot'"
					[selectedArticles]="sourceMaterialService.SelectedArticles"
					(selectedArticlesChange)="
						handleSelectedArticlesChange($event)
					"
					(searchTextChange)="handleSearchTextChange($event, 'mine')"
					(toggleTag)="ToggleTag($event, 'mine')"
					(selectArticles)="handleSelectArticles($event, 'mine')"
					(editArticle)="EditArticle($event)"
					(exportArticle)="
						Select([$event], true, 'mine', false);
						StartArticlesExport()
					"
					(startExport)="StartArticlesExport()"
					(selectAll)="SelectAll($event)"
					(addTagsToSelected)="onAddTagsToSelected($event)"
					(manageTags)="onManageTags()"
					(openFileSettings)="onOpenFileSettings($event)"
				>
				</app-article-search-list>

				<app-article-search-list
					*ngIf="
						sourceMaterialService.GetArticlesByOthers().length > 0
					"
					[sourceArticles]="sourceMaterialService.Articles"
					[searchText]="otherArticlesSearch"
					[owner]="'other'"
					[tableTitle]="'Muut tiedostot'"
					[selectedArticles]="sourceMaterialService.SelectedArticles"
					(selectedArticlesChange)="
						handleSelectedArticlesChange($event)
					"
					(searchTextChange)="handleSearchTextChange($event, 'other')"
					(toggleTag)="ToggleTag($event, 'other')"
					(selectArticles)="handleSelectArticles($event, 'others')"
					(editArticle)="EditArticle($event)"
					(exportArticle)="
						Select([$event], true, 'others', false);
						StartArticlesExport()
					"
					(startExport)="StartArticlesExport()"
					(selectAll)="SelectAll($event)"
					(addTagsToSelected)="onAddTagsToSelected($event)"
					(manageTags)="onManageTags()"
					(openFileSettings)="onOpenFileSettings($event)"
				>
				</app-article-search-list>
			</div>
		} @else {
			<div class="w-100 d-flex justify-content-center align-items-center">
				<div class="row w-100 h-100 text-center">
					<div class="col-12">
						<div
							class="spinner-border"
							style="width: 3rem; height: 3rem"
							role="status"
						></div>
					</div>
					<div class="col-12 pt-3">Ladataan...</div>
				</div>
			</div>
		}
	}

	<!-- Tags View -->
	@if (selectedView == "tags") {
		<h3 class="pt-4 pb-2">Artikkelit lajiteltuna tageittain</h3>

		@let tags = sourceMaterialService.Tags;

		@for (tag of tags; track tag) {
			<div ngbAccordion>
				<div ngbAccordionItem>
					<h2 ngbAccordionHeader>
						<button ngbAccordionButton>
							<div class="row g-0 w-100">
								<div class="col">
									{{
										tag
											? `${tag.description}`
											: `[Tagi puuttuu]`
									}}
									<!-- add bs badge -->
									<span
										class="badge badge-secondary badge-pill bg-secondary"
									>
										#{{
											tag.description
												? tag.description
												: ""
										}}
									</span>
								</div>
								<div class="col-auto pe-2">
									<button
										class="btn btn-secondary btn-sm px-4 py-2"
										(click)="
											$event.stopPropagation();
											sourceMaterialService.SelectByTags(
												[tag.id],
												sourceMaterialService.Articles
											);
											StartArticlesExport()
										"
									>
										<i class="bi bi-box-arrow-up"></i>
									</button>
								</div>
							</div>
						</button>
					</h2>
					<div ngbAccordionCollapse>
						<div ngbAccordionBody>
							<ng-template>
								<app-article-search-list
									[sourceArticles]="
										sourceMaterialService.Articles
									"
									[searchText]="'#' + tag"
									[owner]="'any'"
									[tableTitle]="''"
									[selectedArticles]="
										sourceMaterialService.SelectedArticles
									"
									(selectedArticlesChange)="
										handleSelectedArticlesChange($event)
									"
									(selectArticles)="
										handleSelectArticles($event, 'others')
									"
									(editArticle)="EditArticle($event)"
									(exportArticle)="
										Select([$event], true, 'others');
										StartArticlesExport()
									"
									(startExport)="StartArticlesExport()"
									(addTagsToSelected)="
										onAddTagsToSelected($event)
									"
									(manageTags)="onManageTags()"
								>
								</app-article-search-list>
							</ng-template>
						</div>
					</div>
				</div>
			</div>
		}
	}
</div>
